export const BONUS_BANDS = [
  { min: 0,   max: 89,  bonus: 0   },
  { min: 90,  max: 94,  bonus: 50  },
  { min: 95,  max: 99,  bonus: 100 },
  { min: 100, max: 104, bonus: 150 },
  { min: 105, max: 109, bonus: 180 },
  { min: 110, max: 999, bonus: 220 },
];

// ─── LESSON CONTENT & QUIZZES ─────────────────────────────────────────────────
